import React from 'react';
import logo from '../assets/logo.png';
import Container from './shared/Container';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-surface-dark text-white">
      <Container className="py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-[2fr_1fr] sm:gap-16">
          <div>
            <div className="flex items-center">
              <img src={logo} alt="Vermillion" className="h-8 w-auto bg-white rounded p-1" />
              <span className="ml-2 text-xl font-semibold">Vermillion</span>
            </div>
            <p className="mt-4 text-slate-400 text-sm leading-relaxed max-w-[22rem]">
              Purpose-built AI for operations teams: document intelligence and deterministic decision automation.
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Solutions</h3>
            <ul className="flex flex-col gap-2">
              <li><a href="/#intake" className="text-slate-400 text-sm transition-colors hover:text-white">Vermillion Intake</a></li>
              <li><a href="/#evident" className="text-slate-400 text-sm transition-colors hover:text-white">Vermillion Evident</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/[0.08] flex flex-col justify-between items-center md:flex-row">
          <p className="text-slate-500 text-sm">
            &copy; {currentYear} Vermillion AI. All rights reserved.
          </p>
          <div className="mt-4 flex gap-6 md:mt-0">
            <a href="/privacy" className="text-slate-500 text-sm transition-colors hover:text-white">Privacy Policy</a>
            <a href="/terms" className="text-slate-500 text-sm transition-colors hover:text-white">Terms of Service</a>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
